<div class="tCol clickCol desktop" id="CellRegistered_{{ item.id }}">
  @if (!registered && !systemManaged && !routerManaged) {
    <span>Not Registered</span>
  }
  @if (registered && !systemManaged && !routerManaged) {
    <span>Registered</span>
  }
  @if (routerManaged) {
    <span>See Router</span>
  }
</div>
